import { render, staticRenderFns } from "./commManage.vue?vue&type=template&id=3c695bc6&"
import script from "./commManage.vue?vue&type=script&lang=js&"
export * from "./commManage.vue?vue&type=script&lang=js&"
import style0 from "./commManage.vue?vue&type=style&index=0&id=3c695bc6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports